import { ProfessionalDirectoryLayout } from '@/components/professionals/ProfessionalDirectoryLayout';

export default function ProfessionalDirectory() {
  return <ProfessionalDirectoryLayout />;
}